import Vue from 'vue';
import axios from '../plugins/axios';
import qs from 'qs';

const api = {
  /**
   * 检测是否已登录（域账号自动登录）
   * @param {Object} params - 请求参数
   * @returns {Promise} Promise实例
   */
  checkLogin(params) {
      return axios.get('/api/sso/ajax', {
          params
      });
  },

  /**
   * 清空用户会话
   * @param {Object} params - 请求参数
   * @returns {Promise} Promise实例
   */
  cleanSession(params) {
      return axios.put('/api/sso/cleansession', qs.stringify(params));
  },

  /**
   * 获取RSA公钥
   * @param {Object} params - 请求参数
   * @returns {Promise} Promise实例
   */
  getRSAPublicKey(params) {
      return axios.get('/api/rsa/public-key', {
          params
      });
  },

  checkWhiteList() {
    return axios.get('/api/sso/check/whitelist', {});
  },

  /**
   * 通过加密密码进行登录
   * @param {Object} params - 请求参数
   * @returns {Promise} Promise实例
   */
  loginByEncrypt(params) {
      return axios.post('/api/sso/loginbyencryptandgeetest', qs.stringify(params));
  },

  /**
   * 通过短信验证码进行登录
   * @param {Object} params - 请求参数
   * @returns {Promise} Promise实例
   */
//   loginBySMS(params) {
//       return axios.post('/api/sso/sms/loginbygeetest', qs.stringify(params));
//   },
  loginBySMS(params) {
    return axios.post('/api/sso/sms/checkBySmsCode', qs.stringify(params));
},
  /**
   * 获取短信验证码
   * @param {Object} params - 请求参数
   * @returns {Promise} Promise实例
   */
  fetchSMSCaptcha(params) {
      return axios.post('/api/sso/mobileMSGByGeetest', qs.stringify(params));
  },

  /**
   * 获取二次认证（Two-Factor Authentication）短信验证码
   * @param {Object} params - 请求参数
   * @returns {Promise} Promise实例
   */
  fetchTFASMSCaptcha(params) {
      return axios.get('/api/sso/second-certification-captcha', {
          params
      });
  },

  /**
   * 完成二次认证
   * @param {Object} params - 请求参数
   * @returns {Promise} Promise实例
   */
  completeTFA(params) {
      return axios.post(
          '/api/sso/second-certification-complete',
          qs.stringify(params)
      );
  },

  /**
   * 获取唯一签名进行扫码登录
   * @param {Object} params - 请求参数
   * @returns {Promise} Promise实例
   */
  getUniqueSignOfQRKey(params) {
      return axios.get('/api/sso/uniqueSignOfQRKey', {
          params
      });
  },

  /**
   * 检测唯一签名是否依然有效，以及用户是否已扫码完成登录
   * @param {Object} params - 请求参数
   * @returns {Promise} Promise实例
   */
  checkUniqueSignIsExistAndIsLogin(params) {
      return axios.get('/api/sso/checkUniqueSignIsExistAndIsLogin', {
          params
      });
  },

  /**
  * 国际站域列表查询
  * @returns {Promise} Promise实例
  */
  fetchDomains() {
      return axios.get('/api/sso/domain/list');
  }
};

Vue.api = api;
Vue.prototype.$api = api;

export default api;
